module.exports = __webpack_public_path__ + "static/media/webdesign-services-img61.cb8f7ad4.jpg";